import { logger } from "@/helpers/tslog";
import { removeSelectedShape } from "./sharePricePerformance/selectedPlaceHolderLocalStorage";
import { clearCandidatePlaceholders } from "./candidatePlaceholders";

/**
 * Clears all positioning and related localStorage keys
 * This function removes all stored data related to positioning, templates, and form data
 */
export const clearPositioningLocalStorage = () => {
  try {
    // Clear positioning-related localStorage keys
    localStorage.removeItem("selectedSourcePositioning");
    localStorage.removeItem("selectedNotesPositioning");
    localStorage.removeItem("selectedPlaceholderTitle");
    localStorage.removeItem("selectedPlaceholderSubTitle");
    localStorage.removeItem("selectedTitleEnabled");
    localStorage.removeItem("selectedSubTitleEnabled");
    localStorage.removeItem("selectedSourceEnabled");
    localStorage.removeItem("selectedSourceValue");
    localStorage.removeItem("selectedNotesEnabled");
    localStorage.removeItem("selectedNotesValue");
    localStorage.removeItem("selectedFormatTemplate");
    localStorage.removeItem("tradingVolume");
    localStorage.removeItem("alphaCreateData");
    localStorage.removeItem("PlaceholderPopupFlag");
    localStorage.removeItem("AlphaAgentPlaceholder");
    localStorage.removeItem("ModelData");
    localStorage.removeItem("PanelsData");
    localStorage.removeItem("currencySelectionSlotValue");
    localStorage.removeItem("messages");

    removeSelectedShape();
    clearCandidatePlaceholders();
    
    logger.info("Successfully cleared all positioning and related localStorage keys");
  } catch (error) {
    logger.error("Error clearing localStorage:", error);
  }
};

/**
 * Clears only positioning-related localStorage keys (source and notes positioning)
 * This function only removes positioning selections, keeping other data intact
 */
export const clearPositioningSelections = () => {
  try {
    localStorage.removeItem("selectedSourcePositioning");
    localStorage.removeItem("selectedNotesPositioning");
    localStorage.removeItem("selectedPlaceholderTitle");
    localStorage.removeItem("selectedPlaceholderSubTitle");
    
    logger.info("Successfully cleared positioning selections from localStorage");
  } catch (error) {
    logger.error("Error clearing positioning selections:", error);
  }
};

/**
 * Clears only template-related localStorage keys
 * This function only removes template selections, keeping other data intact
 */
export const clearTemplateSelections = () => {
  try {
    localStorage.removeItem("selectedFormatTemplate");
    
    logger.info("Successfully cleared template selections from localStorage");
  } catch (error) {
    logger.error("Error clearing template selections:", error);
  }
};

/**
 * Clears all localStorage keys used by the application
 * This is a comprehensive clear function that removes all stored data
 */
export const clearAllApplicationData = () => {
  try {
    // Clear all known localStorage keys
    const keysToRemove = [
      "selectedSourcePositioning",
      "selectedNotesPositioning", 
      "selectedFormatTemplate",
      "alphaCreateData",
      "ModelDataToBackend",
      "tradingVolume",
      "PlaceholderPopupFlag",
      "AlphaAgentPlaceholder"
    ];
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    logger.info("Successfully cleared all application data from localStorage");
  } catch (error) {
    logger.error("Error clearing all application data:", error);
  }
};
